export default __webpack_public_path__ + "static/media/pbix.db8d5181.png";